export default __webpack_public_path__ + "static/speedy3-a3ba96cb44ae49d46e782e65a6ebd296.svg";